module.exports = __webpack_public_path__ + "assets/pdf/cycle4-plan-california.8a95fe81.pdf";